import { render, staticRenderFns } from "./SuggestedProductSlider.vue?vue&type=template&id=d7512e6a&scoped=true&"
import script from "./SuggestedProductSlider.vue?vue&type=script&lang=js&"
export * from "./SuggestedProductSlider.vue?vue&type=script&lang=js&"
import style0 from "./SuggestedProductSlider.vue?vue&type=style&index=0&id=d7512e6a&scoped=true&lang=css&"
import style1 from "./SuggestedProductSlider.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7512e6a",
  null
  
)

export default component.exports